import axios from '@axios'
import Point from '@/mixins/classes/point'
import i18n from "@/libs/i18n";
const getDefaultPoint = () => ({
  id: '',
  point_type_id: null,
  point_purpose_ids: [],
  name: '',
  description: '',
  lng: 0,
  lat: 0,
  post_status: 'draft',
  lang: i18n.locale,
  location_radius: null,
  viewport:{},
  address: {
    country: '',
    country_code: '',
    state: '',
    locality: '',
    locality_type: '',
    municipality: '',
    county: '',
    state_district: '',
    province: '',
    suburb: '',
    district: '',
    quarter: '',
    borough: '',
    city_district: '',
    neighbourhood: '',
    man_made: '',
    building: '',
    road: '',
    house_number: '',
    apartment_number: '',
    postcode: '',
    address_comment: '',
    address_confirmed: null,
    unit_id:''

  },
})
function normalizeHours(hours) {
  const inputHours = Array.isArray(hours) ? hours : []

  const hoursMap = inputHours.reduce((map, day) => {
    map[day.weekday_number] = { ...day } // preserve backend ID if exists
    return map
  }, {})

  const normalized = Array.from({ length: 7 }, (_, i) => {
    const dayNumber = i + 1
    if (hoursMap[dayNumber]) {
      const d = { ...hoursMap[dayNumber] }
      // Ensure closed is a boolean for stable diffs
      d.closed = d.closed == null
          ? (d.start_in_minutes == null && d.end_in_minutes == null && d.pause_in_minutes == null && d.resume_in_minutes == null)
          : !!d.closed
      return d
    } else {
      return {
        id: null, // no backend ID yet
        weekday_number: dayNumber,
        start_in_minutes: null,
        pause_in_minutes: null,
        resume_in_minutes: null,
        end_in_minutes: null,
        closed: true,
      }
    }
  })

  return normalized
}
export default {
  namespaced: true,
  state: {
    pointTypesAndPurposes: [],
    point: getDefaultPoint(),
    offers: [],
    userOffers: [],
    filter:{},
    loading:false,
    hours: [],          // reactive hours (used in form)
    originalHours: [],  // snapshot from backend (for diff in edit mode)
    pending: 0
  },
  getters: {
    pointTypesAndPurposes: state => state.pointTypesAndPurposes,
    point: state => state.point,
    Point: state => new Point(state.point),
    offers: state => state.offers,
    userOffers: state => state.userOffers,
    filter:state => state.filter,
    hours: state => state.hours,
    loading: state => state.pending > 0,
  },
  mutations: {
    startLoading(state) { state.pending++ },
    doneLoading(state) { state.pending = Math.max(0, state.pending - 1) },
    resetLoading(state) { state.pending = 0 },
    UPSERT_OFFER(state, offerPayload) {
      // Normalize to Point instance (offers list currently stores `new Point(...)`)
      const offer = offerPayload instanceof Point
        ? offerPayload
        : new Point(offerPayload)

      const index = state.offers.findIndex(o => o.id === offer.id)

      if (index === -1) {
        // New offer, add to list (top)
        state.offers.unshift(offer)
      } else {
        // Existing offer – replace it reactively
        state.offers.splice(index, 1, offer)
      }
    },
    UPSERT_USER_OFFER(state, offerPayload) {
      const offer = offerPayload instanceof Point
        ? offerPayload
        : new Point(offerPayload)

      const index = state.userOffers.findIndex(o => String(o.id) === String(offer.id))

      if (index === -1) {
        state.userOffers.unshift(offer)
      } else {
        state.userOffers.splice(index, 1, offer)
      }
    },

    setUserOffers(state, offers) {
      state.userOffers = Array.isArray(offers)
        ? offers.map(offer => (offer instanceof Point ? offer : new Point(offer)))
        : []
    },

    resetUserOffers(state) {
      state.userOffers = []
    },

    removeUserOffer(state, id) {
      state.userOffers = state.userOffers.filter(offer => String(offer.id) !== String(id))
    },
    // Called after fetching hours from backend
    INIT_HOURS(state, hours) {
      const normalized = normalizeHours(hours)
      state.hours = normalized
      state.originalHours = JSON.parse(JSON.stringify(normalized)) // deep copy
    },
    // Called when editing hours in the form
    SET_HOURS(state, hours) {
      state.hours = normalizeHours(hours)
    },
    SET_ORIGINAL_HOURS(state, hours) {
      const normalized = normalizeHours(hours)
      // Store backend snapshot for diffing later
      state.originalHours = JSON.parse(JSON.stringify(normalized)) // deep copy
    },

    UPDATE_HOUR(state, { index, newHour }) {
      state.hours.splice(index, 1, newHour)
    },
    setPointTypesAndPurposes(state, payload) {
      state.pointTypesAndPurposes = Array.isArray(payload)
        ? payload
        : payload && typeof payload === 'object'
          ? Object.values(payload)
          : []
    },
    setPoint(state, point) {
      state.point = point
    },
    deletePoint(state) {
      state.point = {}
    },
    setOffers(state, offers) {
      state.offers = offers
    },
    setFilter(state, filter) {
      state.filter = filter
    },
  },
  actions: {
    // Point Options
    setPointTypesAndPurposes(ctx, pointTypesAndPurposes) {
      ctx.commit('setPointTypesAndPurposes', pointTypesAndPurposes)
    },
    fetchPointPurposes(ctx, queryParams) {
      return axios.get('/point-purposes?include=point_type', {
        params: queryParams,
      })
        .catch(error => console.log(error))
    },
    async getPointTypesAndPurposes({ getters, dispatch }) {
      if (Array.isArray(getters.pointTypesAndPurposes) && getters.pointTypesAndPurposes.length) {
        return { status: '200', data: getters.pointTypesAndPurposes }
      }

      const response = await axios.get('/point-types?include=point_purposes').catch(error => console.log(error))
      if (response.status === 200) {
        // const pointTypesAndPurposes = extendPointTypesAndPurposes(response.data.data)
        const pointTypesAndPurposes = response.data.data
        dispatch('setPointTypesAndPurposes', pointTypesAndPurposes)
        return ({ status: response.status, data: pointTypesAndPurposes })
      }
      return { status: 0 }
    },
    // Points
    async addPoint(ctx, point) {
      const response = await axios.post('/points', point).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
        ctx.commit('setPoint', response.data.data)
      }
      return response
    },
    async updatePoint(ctx, point) {
      const response = await axios.patch(`/points/${point.id}`, point.data).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setPoint', response.data.data)
        response.statusText = 'updated'
      }
      return response
    },
    async fetchPoint(ctx, { id }) {
      const response = await axios.get(`/points/${id}?include=user,point_type,point_purposes,main_image,media_files`).catch(error => {
        if (error.response.status === 404) {
          return error.response
        }
        console.log(error)
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setPoint', response.data.data)
      }
      return response
    },
    async deletePoint(ctx, { id }) {
      const response = await axios.delete(`/points/${id}`).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'deleted'
      }
      return response
    },
    async fetchPoints(ctx, queryParams) {
      const response = await axios.get('/points?include=user,point_type,point_purposes,main_image,media_files', {
        params: queryParams,
      }).catch(error => console.log(error))
      return response
    },
    async fetchPublicServiceRequests(ctx, queryParams) {
      const response = await axios.get('/public/service-requests?include=point_type,point_purposes,address', {
        params: queryParams,
      }).catch(error => console.log(error))
      return response
    },
    // Service Offers
    async addServiceOffer(ctx, point) {
      const response = await axios.post('/service-offers', point)
        .catch(error => console.log(error))

      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        const created = response.data.data

        response.statusText = 'added'
        ctx.commit('setPoint', created)
        ctx.commit('UPSERT_OFFER', created)
        ctx.commit('UPSERT_USER_OFFER', created)
      }
      return response
    },
    async updateServiceOffer(ctx, point) {
      const response = await axios.patch(`/service-offers/${point.id}`, point)
        

      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        const updated = response.data.data

        ctx.commit('setPoint', updated)
        ctx.commit('UPSERT_OFFER', updated)
        ctx.commit('UPSERT_USER_OFFER', updated)

        // Refresh the canonical authenticated user after the offer is saved.
        // Marketing assets read service offers from account.user.service_offers.
        try {
          await ctx.dispatch('account/fetchUserCurrent', null, { root: true })
        } catch (error) {
          // The offer was already saved successfully; profile refresh must not turn it into a failed save.
          console.error('Failed to refresh current user after service offer update:', error)
        }

        response.statusText = 'updated'
      }
      return response
    },
    async fetchServiceOffer(ctx, { id }) {
      const response = await axios.get(`/service-offers/${id}?include=user.languages,point_type,main_image,media_files,point_purposes.tags,address,business_hours`).catch(error => {
        if (error.response.status === 404) {
          return error.response
        }
        console.log(error)
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setPoint', response.data.data)
      }
      return response
    },

    async deleteServiceOffer(ctx, { id }) {
      const response = await axios.delete(`/service-offers/${id}`).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('removeUserOffer', id)
        response.statusText = 'deleted'
      }
      return response
    },
    async fetchServiceOffers(ctx, queryParams) {
      const response = await axios.get('/service-offers?include=user,point_type,point_purposes,main_image,media_files,address', {
        params: queryParams,
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setOffers', response.data.data.map($item => new Point($item)))
      }
      return response
    },
    async fetchServiceOffersPublic(ctx, queryParams) {
      const response = await axios.get('/public/service-offers?include=user.languages,media_files,address', {
        params: queryParams,
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setOffers', response.data.data.map($item => new Point($item)))
      }
      return response
    },
    async fetchUserServiceOffers(ctx, queryParams = {}) {
      const response = await axios.get('/service-offers?include=user,point_type,point_purposes,main_image,media_files,address', {
        params: {
          postOwner: 'me',
          ...queryParams,
        },
      })

      const successStatuses = [200, 201]

      if (successStatuses.includes(response.status)) {
        ctx.commit('setUserOffers', response.data.data)
      }

      return response
    },

    // Service Requests
    async addServiceRequest(ctx, point) {
      const response = await axios.post('/service-requests', point)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
        ctx.commit('setPoint', response.data.data)
      }
      return response
    },
    async addServiceRequestManaged(ctx, point) {
      const response = await axios.post('/service-requests/managed', point)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
        ctx.commit('setPoint', response.data.data)
      }
      return response
    },
    async addAccessHours({ commit }, accessHours) {
      const response = await axios.post('/access-hours', accessHours)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
        // const hours = Array.isArray(data.data) ? data.data : [data.data]
        // ctx.commit('setPointAccessHours', hours)
        // commit('SET_HOURS', hours)
      }
      return response
    },
    async addBusinessHours({ commit }, businessHours) {
      const response = await axios.post('/business-hours', businessHours)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
        // const hours = Array.isArray(data.data) ? data.data : [data.data]
        // ctx.commit('setPointAccessHours', hours)
        // commit('SET_HOURS', hours)
      }
      return response
    },

    async fetchAccessHours({ commit }, queryParams) {
      try {
        const { data } = await axios.get('/access-hours', {
          params: queryParams,
        })
        const hours = Array.isArray(data.data) ? data.data : [data.data]
        commit('INIT_HOURS', hours) // snapshot + editable copy
        return hours
      } catch (err) {
        console.error('fetchAccessHours failed:', err)
        commit('INIT_HOURS', []) // fallback to empty week
        throw err
      }
    },
    async fetchBusinessHours({ commit }, queryParams) {
      try {
        const { data } = await axios.get('/business-hours', {
          params: queryParams,
        })
        const hours = Array.isArray(data.data) ? data.data : [data.data]
        commit('INIT_HOURS', hours) // snapshot + editable copy
        return hours
      } catch (err) {
        console.error('fetchBusinessHours failed:', err)
        commit('INIT_HOURS', []) // fallback to empty week
        throw err
      }
    },

    async updateAccessHours(ctx, accessHours) {
      const response = await axios.patch(`/access-hours/${accessHours.id}`, accessHours).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'updated'
      }
      return response
    },
    async updateBusinessHours(ctx, businessHours) {
      const response = await axios.patch(`/business-hours/${businessHours.id}`, businessHours).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'updated'
      }
      return response
    },
    async deleteBusinessHours(ctx, { id }) {
      const response = await axios.delete(`/business-hours/${id}`).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        // ctx.commit('deletePoint')
        response.statusText = 'deleted'
      }
      return response
    },
    async deleteAccessHours(ctx, { id }) {
      const response = await axios.delete(`/access-hours/${id}`).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        // ctx.commit('deletePoint')
        response.statusText = 'deleted'
      }
      return response
    },
    async updateServiceRequest(ctx, point) {
      const response = await axios.patch(`/service-requests/${point.id}`, point)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setPoint', response.data.data)
        response.statusText = 'updated'
      }
      return response
    },
    async fetchServiceRequest(ctx, { id }) {
      const response = await axios.get(`/service-requests/${id}?include=user.languages,point_type,point_purposes,main_image,media_files,events,manager.languages,receiver.languages,address`).catch(error => {
        if (error.response.status === 404) {
          return error.response
        }
        console.log(error)
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setPoint', response.data.data)
      }
      return response
    },

    async fetchServiceRequestPublic(ctx, { id }) {
      const include =
        'user.languages,point_type,point_purposes,main_image,media_files,events,manager.languages,receiver.languages,address'

      const response = await axios
        .get(`/public/service-requests/${id}?include=${include}`)
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return error.response
          }

          // eslint-disable-next-line no-console
          console.log(error)
          throw error
        })

      const successStatuses = [200, 201]

      if (successStatuses.includes(response.status)) {
        ctx.commit('setPoint', response.data.data)
      } else {
        ctx.commit('setPoint', undefined)
      }

      return response
    },

    async deleteServiceRequest(ctx, { id }) {
      const response = await axios.delete(`/service-requests/${id}`).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('deletePoint')
        response.statusText = 'deleted'
      }
      return response
    },
    async closeServiceRequest(ctx, { id, close_reason }) {
      const response = await axios.post(`/service-requests/${id}/close`, { data: { close_reason } }).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'closed'
      }
      return response
    },
    async fetchServiceRequests(ctx, args) {
      let include = [
        'user',
        'point_type',
        'point_purposes',
        'main_image',
        'media_files',
        'events',
        'manager',
        'receiver',
        'address'
      ]
      if (args.include){
        include = args.include
        delete args.include
      }
      include = include.join(',')
      return await axios.get(`/service-requests?include=${include}`, {
        params: args,
      })
        .catch(error => console.log(error))
    },
    async fetchSearchServiceRequests(ctx, queryParams) {
      return await axios.get('/search-service-requests?include=user,point_type,point_purposes,main_image,media_files,events,manager,receiver', {
        params: queryParams,
      })
    },
    async fetchSearchServiceRequest(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/search-service-requests/${id}?include=user.languages,point_type,point_purposes,main_image,media_files,events,manager.languages,receiver.languages,address,referral_events.organizer,access_hours`)
          .then(response => {
            const successStatuses = [200, 201]
            if (successStatuses.includes(response.status)) {
              ctx.commit('setPoint', response.data.data)
            }
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    // Images
    async addImages(ctx, formData) {
      const response = await axios.post('/images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
      }
      return response
    },
    async deleteImages(ctx, data) {
      const response = await axios.delete(`/points/${data.pointId}/images?image_ids=${data.imageIds}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).catch(error => console.log(error))
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'deleted'
      }
      return response
    },
    async getServiceGroupId() {
      const res = await axios.post('/service-groups', {})
      // Accept either { data: { id } } or { id }
      return res?.data?.data?.id || res?.data?.id
    },
    async captureServiceRequest(ctx, { id }) {
      const response = await axios
          .post(`/service-requests/${id}/capture?include=user.languages,point_type,point_purposes,main_image,media_files,events,manager.languages,receiver.languages,address`)
          .catch(error => console.log(error))

      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'captured'
        ctx.commit('setPoint', response.data.data)
      }

      return response
    },
  },
}
